// =============================================================================
// features/conversations/hooks/useScheduledAppointment.ts — Detalhe de um
// compromisso da agenda comercial, para a confirmação inline do botão
// "Agendar retorno" (F33-S08, doc 26 §6.4/§7).
//
// Query key ISOLADA (`['conversations','schedule-return','appointment', id]`)
// — não compartilha nem colide com nenhuma chave de conversations/mensagens
// nem com as chaves de features/sales/agenda/hooks.ts. Único propósito: ler
// horário + responsável do compromisso que acabou de ser criado pelo
// `ScheduleAppointmentDialog`, sem tocar em realtime/socket da conversa.
// =============================================================================

import { AppointmentSchema, type Appointment } from '@elemento/shared-schemas';
import { useQuery } from '@tanstack/react-query';

import { api } from '../../../lib/api';

async function fetchAppointment(id: string): Promise<Appointment> {
  const raw = await api.get<unknown>(`/api/sales/appointments/${encodeURIComponent(id)}`);
  return AppointmentSchema.parse(raw);
}

export function useScheduledAppointment(id: string | null): {
  appointment: Appointment | undefined;
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery({
    queryKey: ['conversations', 'schedule-return', 'appointment', id ?? 'disabled'] as const,
    queryFn: () => fetchAppointment(id as string),
    enabled: id !== null,
    staleTime: 30_000,
  });

  return { appointment: data, isLoading };
}
